import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "-mx-2"
};
const _hoisted_2 = {
  class: "flex flex-col items-center text-center p-4 -mx-12"
};
const _hoisted_3 = {
  class: "font-bold text-xl"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "font-bold text-lg text-green-300"
};
const _hoisted_6 = {
  class: "flex items-center"
};
const _hoisted_7 = {
  class: "mr-1"
};
const _hoisted_8 = {
  class: "font-bold text-green-600"
};
const _hoisted_9 = {
  class: "flex-center"
};
import CurrencyLayout from "./CurrencyLayout.vue";
import { app } from "@/di";
import GateManager from "@/modules/action-points/services/GateManager";
import { TYPES } from "@/modules/action-points/types";
import { EventEmitter } from "@/modules/base/events";
import AfterCurrencyChangeEvent from "@/modules/action-points/ events/AfterCurrencyChangeEvent";
import { GateTypeEnum } from "@/modules/action-points/enums";
import SlideSelect from "@/modules/vue/components/SlideSelect.vue";
import { Team } from "@/modules/team/entity";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'BuyCoinsPage',
  async setup(__props) {
    let __temp, __restore;
    const team = ref();
    const currentCoins = ref();
    const products = ref();
    const selectedProduct = ref();
    const coinsGate = app.get(GateManager).getGate(GateTypeEnum.COINS);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.current();
      currentCoins.value = await coinsGate.currency.get();
      products.value = await app.get(TYPES.CoinsSeller).getProducts();
    })), __temp = await __temp, __restore(), __temp);
    onMounted(() => selectedProduct.value = products.value[0]);
    onBeforeUnmount(app.get(EventEmitter).onOff([AfterCurrencyChangeEvent], refresh));
    const message = useMessage();
    const onBuyCoins = async () => {
      await app.get(TYPES.CoinsSeller).buy(selectedProduct.value);
      await coinsGate.currency.add(selectedProduct.value.coins);
      message.success(translator.t('done'));
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(CurrencyLayout, null, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('buy_coins')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(SlideSelect, {
          modelValue: selectedProduct.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedProduct.value = $event),
          items: products.value,
          class: "bg-slate-500 text-slate-50"
        }, {
          item: _withCtx(({
            item
          }) => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.Coins,
            class: "text-gold-500 mb-2"
          }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1), item.description ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.description), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$n(item.price)) + "€", 1)])]),
          _: 1
        }, 8, ["modelValue", "items"])]), selectedProduct.value ? (_openBlock(), _createBlock(FormGroup, {
          key: 0,
          class: "mb-8",
          label: _ctx.$t('coins'),
          "value-width-ratio": 1 / 2
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(Math.floor(currentCoins.value)), 1), _createElementVNode("span", _hoisted_8, "+ " + _toDisplayString(_ctx.$n(selectedProduct.value.coins)), 1)])]),
          _: 1
        }, 8, ["label"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createVNode(_component_NButton, {
          secondary: "",
          type: "success",
          size: "large",
          onClick: onBuyCoins
        }, {
          default: _withCtx(() => [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.Coins,
            class: "mr-2"
          }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_ctx.$t('buy_coins')), 1)]),
          _: 1
        })])]),
        _: 1
      });
    };
  }
});